import EventEmitter from "./event-emitter";
import {FormFieldValidator, notEmptyValidator} from "./validators";

export default class FormFieldController {
    constructor(props = {}) {
        this.name = props.name;
        this.validators = props.validators || [];
        this.required = props.required || false;
        this.disabled = props.disabled || false;
        this.cacheable = props.cacheable || false;
        this.unsendable = props.unsendable || false;
        this.subscriptions = props.subscriptions;

        this._value = null;
        this._valid = false;
        this._eventEmitter = new EventEmitter(this.subscriptions);

        this.VALUE_CHANGE_EVENT = 'valueChange';
        this.VALIDATION_STATUS_CHANGE_EVENT = 'validationStatusChange';
        this.INITIAL_VALUE_SET_EVENT = 'initialValueSet';
        this.STATE_DROPPED_EVENT = 'stateDropped';

        this.init();
    }

    get value() {
        return this._value;
    }

    get valid() {
        return this.required ? this._valid : true;
    }

    init() {
        this._checkProps();

        if (this.required) {
            this.validators.unshift(notEmptyValidator);
        }
    }

    validate(valid) {
        if (!this.required) {
            return;
        }

        this._valid = this.validators.every((validator) => {
            if (validator instanceof FormFieldValidator) {
                return validator.validate(this._value);
            } else if (validator instanceof RegExp) {
                return validator.test(this._value);
            }

            return validator(this._value);
        });

        if (valid === false) {
            this._valid = false;
        }

        this._eventEmitter.dispatch(this.VALIDATION_STATUS_CHANGE_EVENT, this._valid);
    }

    setValue(value, options = {}) {
        if (this.disabled || this._checkValuesEquality(value, this._value)) {
            return;
        }

        const validate = options.validate == null ? true : options.validate;
        const dispatchEvent = options.dispatchEvent == null ? true : options.dispatchEvent;

        this._value = value;

        if (validate) {
            this.validate();
        }

        if (dispatchEvent) {
            this._eventEmitter.dispatch(this.VALUE_CHANGE_EVENT, this._value);
        }
    }

    getValue() {
        return this._value;
    }

    setInitialValue(value, options = {}) {
        this.setValue(value, options);
        this._eventEmitter.dispatch(this.INITIAL_VALUE_SET_EVENT);
    }

    dropState() {
        this.setValue(null);
        this._eventEmitter.dispatch(this.STATE_DROPPED_EVENT);
    }

    subscribe(event, callback) {
        return this._eventEmitter.subscribe(event, callback);
    }

    dispatch(event, data) {
        this._eventEmitter.dispatch(event, data);
    }

    addSubscriptions(subscriptions) {
        return this._eventEmitter.addSubscriptions(subscriptions);
    }

    addValidator(validator, options = {}) {
        if (typeof validator !== 'function' &&
            !(validator instanceof FormFieldValidator) &&
            !(validator instanceof RegExp)) {
            throw new Error('FormFieldController: Wrong validators field type.');
        }

        this.validators.push(validator);

        if (options.revalidate === true) {
            this.validate();
        }
    }

    _checkProps() {
        if (!this.name) {
            throw new Error('FormFieldController: Name is not defined!');
        }

        if (!this.validators || !Array.isArray(this.validators)) {
            throw new Error('FormFieldController: Wrong validators field type.');
        }

        if (this.validators.some((validator) => (
            typeof validator !== 'function' &&
            !(validator instanceof FormFieldValidator) &&
            !(validator instanceof RegExp)
        ))) {
            throw new Error('FormFieldController: Wrong validators field type.');
        }
    }

    _checkValuesEquality(value1, value2) {
        return JSON.stringify({ value: value1 }) === JSON.stringify({ value: value2 });
    }
}